import React from 'react';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { useMeasurement } from '~/utility/BinSentry-ui-utility';
import { makeStyles,Typography, Button, Container, Icons } from '~/lib/bn-material-ui';
import { useOrdersDialogStateSelector, useOrdersDialogDispatch } from '../context/orders-dialog-context';
import { SiteFeedOrderTable } from './site-feed-order-table';
import { ACTION_ROW_MOBILE_HEIGHT_REM } from './orders-dialog-content';

const useSiteFeedOrderStyles = makeStyles(({ breakpoints }) => ({
  container: {
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    [breakpoints.down('sm')]: {
      paddingLeft: '0px',
      paddingRight: '0px',
      marginBottom: `${ACTION_ROW_MOBILE_HEIGHT_REM}rem`,
    },
  },
}));
export function SiteFeedOrder() {
  const styles = useSiteFeedOrderStyles();

  return (
    <Container className={styles.container} maxWidth='xl'>
      <SiteFeedOrderHeader />
      <SiteFeedOrderTable />
      <SiteFeedOrderFooter />
    </Container>
  );
}

const useHeaderStyles = makeStyles(({ breakpoints }) => ({
  header: {
    marginBottom: '0.5rem',
    whiteSpace: 'nowrap',
    [breakpoints.down('sm')]: {
      paddingLeft: '1.125rem',
    },
  },
  title: {
    display: 'inline',
    marginRight: '.5rem',
  },
}));

function SiteFeedOrderHeader() {
  const styles = useHeaderStyles();
  const [siteEntity, isoDate] = useOrdersDialogStateSelector(['siteEntity', 'isoDate']);
  const formattedDate = isoDate ? DateTime.fromISO(isoDate).toFormat('LLLL d, yyyy') : '';

  return (
    <div className={styles.header}>
      <Typography variant='h3' className={styles.title}>Site Feed Order - {siteEntity?.properties.name} </Typography><span>{formattedDate}</span>
    </div>
  );
}

const useFooterStyles = makeStyles(({ breakpoints }) => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '0.25rem',
    [breakpoints.down('sm')]: {
      paddingLeft: '1.125rem',
      paddingRight: '1.125rem',
    },
  },
  dailyTotal: {
    fontWeight: 'bold',
    margin: '.5rem 0 .5rem auto',
  },
}));

function SiteFeedOrderFooter() {
  const styles = useFooterStyles();
  const [daysOrders, feeds, createOrEditSirenAction] = useOrdersDialogStateSelector(['daysOrders', 'feeds', 'createOrEditSirenAction']);
  const dispatch = useOrdersDialogDispatch();
  const orderMeasurement = useMeasurement({ name: 'orderAmount' });

  const hasDaysOrders = !!daysOrders;
  const totalFeedQuantity = hasDaysOrders ?
    _.sumBy(daysOrders, (order) => {
      const ordersFeedEntity = feeds?.find(
        feedEntity => feedEntity.getLinkByRel('self').href === order.getSubEntityByRel('https://api.binsentry.com/rel/feed')?.href,
      );
      const { bulkDensity } = ordersFeedEntity?.properties || {};
      return orderMeasurement.convert({ volume: order.properties.quantity, bulkDensity });
    }) :
    undefined;

  return (
    <div className={styles.footer}>
      {createOrEditSirenAction && (
        <Button
          variant='text'
          onClick={() => dispatch({ type: 'specify-new-order' })}
        >
          <Icons.Add /> Add Order
        </Button>
      )}
      <Typography variant='body2' className={styles.dailyTotal}>
        {hasDaysOrders && (
          <>Daily Load Total: {totalFeedQuantity.toFixed(2)} {orderMeasurement.unit}</>
        )}
      </Typography>
    </div>
  );
}

